// axiosInstance.ts
import axios from "axios";
import { ServerBaseUrl } from "../routes";
import { createBrowserHistory } from "history";
import { getToken, removeToken } from "./token";

export const history = createBrowserHistory();

const axiosInstance = axios.create({
  baseURL: ServerBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Read the token on every request: it changes after login, and a value
// captured at module load would be stale (or "null") until a full reload.
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.set("authorization", `Bearer ${token}`);
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
